// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","remainingAccessWrap":"TP0Xy7mesNAMK75tjG_cl","remainingAccessHeading":"_1M_3URjGHRTkD71K-tBZv2"};